import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
  CircularProgress,
  Box,
  Button,
  Switch,
} from '@mui/material';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, { API_ROUTES } from '../../../utils/constant';
import { useRouter } from '../../../hooks/use-router';

function TeamsTable() {
  const [tableData, setTableData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const router = useRouter();

  const fetchTeamsList = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await HttpService.get(API_ROUTES.getAllTeams);
      setTableData(response?.data?.data || []);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchTeamsList();
  }, [fetchTeamsList]);

  const addUser = () => {
    router.push(PAGE_ROUTES.ADDTEAM);
  };

  const handleStatusChange = async (teamId: number, currentStatus: number) => {
    try {
      setLoading(true);
      const newStatus = currentStatus === 1 ? 2 : 1;
      await HttpService.patch(
        API_ROUTES.updateTeam.replace(':teamId', teamId.toString()),
        { status: newStatus }
      );

      fetchTeamsList();
    } catch (error) {
      console.error('Error updating team status:', error);
    } finally {
      setLoading(false);
    }
  };

  function Row(props: { row: any }) {
    const { row } = props;

    return (
      <React.Fragment>
        <TableRow>
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.userTeamKey}
          </TableCell>

          <TableCell>
            <Switch
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row.id, row.status)}
              inputProps={{ 'aria-label': 'controlled' }}
              color="primary"
            />
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { md: 'column', lg: 'row' },
          justifyContent: 'flex-end',
          padding: '20px 0',
          gap: 1,
        }}
      >
        <Box>
          <Button
            variant="contained"
            onClick={addUser}
            sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
          >
            Add Teams
          </Button>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Team Name</TableCell>
              <TableCell align="left">Is Active</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(tableData || []).map((data: any) => (
              <Row key={data.id} row={data} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default TeamsTable;
